module.exports = __webpack_public_path__ + "static/media/tiffanylau.f283bb46.jpeg";